import { setReferenceLanguage } from "../../app/slices/TrainingSlice";
import { LanguageData } from "../../app/slices/TrainingLocalizationSlice";
import PiPopoverMenu from "../../components/PiPopoverMenu";
import PiMenuButton from "../menu/PiMenuButton";
import { useDispatch, useSelector } from "react-redux";
import { selectReferenceLanguage } from "../../app/slices/TrainingSlice";
import { useTranslation } from "react-i18next";
import useAutotranslation from "./AutoTranslationHook";
import { useDeleteLanguage } from "./DeleteLanguageHook";
import { useSetLanguageIncludeInPublish } from "./TrainingLocalizationHooks";

export default function TrainingLocalizationTableCellMenu(props: {
  languageData: LanguageData;
}) {
  const { languageData } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const refLanguage = useSelector(selectReferenceLanguage);
  const { translateMultipleMissing, translateMultipleAll } =
    useAutotranslation();
  const { deleteLanguage } = useDeleteLanguage();
  const { setIncludeInPublish } = useSetLanguageIncludeInPublish();

  const handleSetAsRef = async () => {
    dispatch(setReferenceLanguage(languageData.shortcode));

    // If language is not set to include in publish, set it to true
    if (languageData.includeInPublish === false) {
      await setIncludeInPublish(languageData, true);
    }
  };

  return (
    <PiPopoverMenu>
      <PiMenuButton
        text="Translate All"
        onClick={() => translateMultipleAll([languageData])}
        label={"AI"}
        disabled={languageData.shortcode === refLanguage}
      />
      <PiMenuButton
        text="Translate Missing"
        onClick={() => translateMultipleMissing([languageData])}
        label={"AI"}
        disabled={languageData.shortcode === refLanguage}
      />
      <PiMenuButton
        text={t("localization_menu.set_as_ref")}
        onClick={handleSetAsRef}
      />
      <PiMenuButton
        text={t("localization_menu.delete")}
        onClick={() => deleteLanguage(languageData)}
        disabled={languageData.shortcode === refLanguage}
      />
    </PiPopoverMenu>
  );
}
